/**
 * Created by zad on 17/4/25.
 */
import { Trash } from '../constants/actionTypes';
import createAction from '../utils/createAction';

// eslint-disable-next-line import/prefer-default-export
export const getTrashNotesList = createAction(Trash.GET_TRASH_NOTES_LIST, 'isForce');

export const getTrashNote = createAction(Trash.GET_TRASH_NOTE_CONTENT, 'noteId');

export const delTrashNote = createAction(Trash.DEL_TRASH_NOTE, 'noteId', 'doneCallback');

// 恢复文章
export const recoveryTrashNote = createAction(Trash.RECOVERY_TRASH_NOTE, 'noteId', 'doneCallback');




// WEBPACK FOOTER //
// ./src/actions/TrashAction.js